import { Mock } from "../lib/appfuse-react/core/ajax";
import salesService from "../mock/sales";
import iamService from "../mock/iam";
import contentService from "../mock/content";
import qnrService from "../mock/qnr";

const mock = (function() {
    const mock = new Mock();
    mock.use(iamService);
    mock.use(contentService)
    mock.use(salesService);
    mock.use(qnrService)
    return mock;
}());

const context = {mock};

export default context;

export {mock};